var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"recruitment"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("index.Careers")))]),_c('p',[_vm._v(_vm._s(_vm.DataList.list[0].talentRecruitment))]),_c('a',{staticClass:"btn",attrs:{"href":"https://app.mokahr.com/social-recruitment/fertility/39623#/"}},[_vm._v(_vm._s(_vm.$t("indexnav.了解招聘詳情")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }